export const DIRECTIONS = {
    left: 'rotate(90deg)',
    right: 'rotate(-90deg)',
    up: 'rotate(-180deg)',
};
